import React, { useState, useEffect } from 'react';
import LeftSection from './LeftSection';

function MiddleSection() {
  const [wordData, setWordData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDay] = useState(new Date().getDay()); // Fix current day on first load
  const [selectedDay, setSelectedDay] = useState(new Date().getDay()); // Track selected day separately

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Order days based on current day just once
  const getOrderedDays = (currentIndex) => [
    daysOfWeek[currentIndex],
    ...daysOfWeek.slice(0, currentIndex).reverse(),
    ...daysOfWeek.slice(currentIndex + 1).reverse()
  ];

  useEffect(() => {
    const fetchWordData = async () => {
      try {
        // Make the request to Cloudflare Worker API endpoint
        const apiUrl = process.env.REACT_APP_API_URL;
        console.log(apiUrl)
        const response = await fetch(`${apiUrl}/cron`);


        if (response.ok) {
          // Extract the data from the response
          const updatedData = await response.json();
          console.log(updatedData); // Log the data to see the structure in your console
          setWordData(updatedData.data); // Set the data (this assumes `data` is the key in your response)
          setLoading(false);
        } else {
          console.error('Error fetching word data:', response.statusText);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    };

    fetchWordData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (wordData.length === 0) return <p>No words available.</p>;

  const currentWord = wordData[selectedDay % wordData.length];
  const orderedDaysOfWeek = getOrderedDays(currentDay);

  const getHighlightIndex = () => orderedDaysOfWeek.findIndex(day => daysOfWeek[selectedDay] === day);
  const handleDayClick = (clickedDayIndex) => {
    const clickedDayName = orderedDaysOfWeek[clickedDayIndex];
    const newSelectedDayIndex = daysOfWeek.indexOf(clickedDayName);
    setSelectedDay(newSelectedDayIndex);
  };

  return (
    <div className="middle-section">
      <div className="leftContainer">
        <LeftSection
          daysOfWeek={orderedDaysOfWeek}
          onDayClick={handleDayClick} // Update only the selected day
          currentDay={getHighlightIndex()} // Highlight the selected day
        />
      </div>
      <div className="vocab-entry">
        <div className="word">
          <span className="word-text">{currentWord.word}</span>
          <span className="part-of-speech">{currentWord.type}</span>
        </div>
        <div className="meaning"><b>Meaning: </b>{currentWord.meaning}</div>
        <div className="source"><span className="label">Source: </span>{currentWord.source}</div>
        <div className="root"><span className="label">Root: </span>{currentWord.root}</div>
        {currentWord.word0 && (
          <div className="related-words">
            <span className="label">Some of the other words from the same root are:</span>
            <ul>
              {Array.from({ length: 9 }).map((_, i) => (
                currentWord[`word${i}`] && <li key={i}>{currentWord[`word${i}`]}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default MiddleSection;
